import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

function ConfirmacaoPage() {
    const { status } = useParams(); // 'sucesso', 'expirado', 'invalido', 'ja-ativo'
    const [mensagem, setMensagem] = useState('Verificando seu status...');
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        switch (status) {
            case 'sucesso':
                setMensagem('Sua conta foi ativada com sucesso! Agora você já pode fazer o login.');
                setIsSuccess(true);
                break;
            case 'expirado':
                setMensagem('O link de confirmação expirou. Por favor, solicite um novo e-mail de confirmação.');
                setIsSuccess(false);
                break;
            case 'ja-ativo':
                setMensagem('Esta conta já foi ativada. Você pode prosseguir para o login.');
                 setIsSuccess(true);
                break;
            case 'invalido':
            default:
                setMensagem('O link de confirmação é inválido ou já foi utilizado. Se o problema persistir, tente se cadastrar novamente ou contate o suporte.');
                setIsSuccess(false);
                break;
        }
    }, [status]);

    return (
        <div>
            <h2>Status da Ativação da Conta</h2>
            <p>{mensagem}</p>
            {isSuccess && <Link to="/login">Ir para o Login</Link>}
            {!isSuccess && status === 'expirado' && (
                // Opcional: Adicionar um botão para reenviar o e-mail de confirmação
                // Isso exigiria um novo endpoint no backend
                <button>Reenviar E-mail de Confirmação</button>
            )}
        </div>
    );
}

export default ConfirmacaoPage;